import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { IFormItem } from './form-base';

import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { DatePickerComponent } from './components/datepicker/datepicker.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { InputNumberComponent } from './components/inputnumber/inputnumber.component';
import { MultiSelectComponent } from './components/multiselect/multiselect.component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { TextFieldComponent } from './components/text-field/text-field.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { ButtonSetComponent } from './components/buttonset/buttonset.component';
import { InputMaskComponent } from './components/input-mask/input-mask.component';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DatePickerComponent,
    TextFieldComponent,
    InputNumberComponent,
    TextareaComponent,
    DropdownComponent,
    MultiSelectComponent,
    RadioButtonComponent,
    CheckboxComponent,
    ButtonSetComponent,
    InputMaskComponent,
  ],
})
export class BaseDynamicFormComponent {
  @Input() formItems: IFormItem[] = [];

  @Input() form!: FormGroup;
  identify(index, item) {
    return item.key;
  }
}
